/*
 * @Description:
 * @Date: 2024-11-25 19:52:23
 */
import { DirectiveBinding } from 'vue';
import appStore from '@/store';
import { storeToRefs } from 'pinia';
const getUserResource = (): string[] => {
  const { resource } = storeToRefs(appStore.useResourceStoreSetup);
  return resource.value;
};
// <button v-resource="['admin']">Admin Only Button</button>

export default {
  beforeMount(el: HTMLElement, binding: DirectiveBinding) {
    const requiredPermissions = binding.value;
    const userPermissions = getUserResource();

    if (
      !requiredPermissions.some(permission =>
        userPermissions.includes(permission)
      )
    ) {
      el.parentNode?.removeChild(el);
    }
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    const requiredPermissions = binding.value;
    const userPermissions = getUserResource();

    if (
      !requiredPermissions.some(permission =>
        userPermissions.includes(permission)
      )
    ) {
      el.parentNode?.removeChild(el);
    }
  }
};
